import axios from "axios";
import Cookies from "js-cookie";
import { useState } from "react";

const {
  postReq,
  showErrorMessage,
  patchReq,
  patchApiReq,
} = require("./ApiHandlers");
const useAuth = () => {
  const getFileUrl = async (data) => {
    return await postReq("/upload", data);
  };
  const generateQr = async (tempToken) => {
    try {
      // const tempToken = Cookies.get("__2fa_temp_token");
      console.log("➡️ generateQr called, tempToken:", tempToken);

      const res = await axios.post(
        "https://api.payfirewallcrypto.com/auth/2fa/generate",
        {},
        {
          headers: {
            Authorization: `Bearer ${tempToken}`,
          },
          withCredentials: true,
        }
      );

      console.log("📥 /auth/2fa/generate response:", res);

      if (res?.data) {
        console.log("✅ QR data received:", res.data);
      } else {
        console.warn("⚠️ No data received from QR API");
      }

      return res;
    } catch (error) {
      console.error("❌ generateQr failed:", error);
      throw error; // re-throw so calling function can handle it
    }
  };

  const verifyUser = async (data, userId) => {
    const response = await patchApiReq(
      `/admin/user-verification?userId=${userId}`,
      data
    );
    if (response.status) {
      return [response.data];
    } else {
      showErrorMessage(response?.error?.message);
    }
  };

  const verifyUserAgain = async (data) => {
    const response = await patchReq("/users/me/verification", data);
    if (response.status) {
      return [response.data];
    } else {
      showErrorMessage(response?.error?.message);
    }
  };

  return {
    getFileUrl,
    verifyUser,
    verifyUserAgain,
    generateQr,
  };
};
export default useAuth;
